export default __webpack_public_path__ + "static/media/menu-master.7f308947.svg";